export default [
  {
    component: 'CNavTitle',
    name: 'Материалы',
  },
  {
    component: 'CNavItem',
    name: 'Список',
    to: '/materials',
    icon: 'cil-list',
  },
  {
    component: 'CNavItem',
    name: 'Категории',
    to: '/materials/categories',
    icon: 'cil-list',
  },
  {
    component: 'CNavTitle',
    name: 'Продукты',
  },
  {
    component: 'CNavItem',
    name: 'Список',
    to: '/products',
    icon: 'cil-pencil',
  },
  {
    component: 'CNavItem',
    name: 'Категории',
    to: '/products/categories',
    icon: 'cil-list',
  },
]
